import React, {useState} from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

/**
 * HOC - High order component. This component is wrapper - adds functionality: props.showAlert to child component
 */

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const withAlert = (Component) => {
    return props => {
        const [alertMessage, setAlertMessage] = useState('')
        const [alertType, setAlertType] = useState('')
        const [alertOpen, setAlertOpen] = useState(false)

        const handleCloseAlertMessage = (event, reason) => {
            if (reason === 'clickaway') {
                return;
            }

            setAlertOpen(false);
        };

        const showAlert = (message, type) => {
            setAlertMessage(message)
            setAlertType(type) // 'success', 'warning' , 'info', 'error'
            setAlertOpen(true)
        }

        const closeAlert = () => {
            setAlertOpen(false)
        }

        return (
            <React.Fragment>
                <Stack spacing={2} sx={{ width: '100%' }}>
                    <Snackbar open={alertOpen} autoHideDuration={4000} onClose={handleCloseAlertMessage}>
                        <Alert onClose={handleCloseAlertMessage} severity={alertType} sx={{ width: '100%' }}>
                            {alertMessage}
                        </Alert>
                    </Snackbar>
                </Stack>
                <Component
                    showAlert={showAlert}
                    closeAlert={closeAlert}
                    {...props}
                />
            </React.Fragment>
        )
    }
}

export default withAlert